<mat-card class="filter settingHeader">
  <div class="name">
    Manage Note Status
  </div>
  <div class="quickAction">
    
    <!-- <mat-form-field appearance="">
      <mat-label>Search items in task status</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->

    <!-- <div class="">         
      <button mat-flat-button color="primary" (click)="openDialogAddWithRef(myAddDialog)"> Add Task Status </button>
   </div> -->

  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldName">Type Name</span>
      <span class="fieldName">Status Name</span>
      <!-- <span class="requried">Active/Inactive</span>
      <span class="editField">Edit</span> -->
      <!-- <span class="delete">Delete</span> -->
    </div>

    <div class="example-box fieldRow" *ngFor="let task of taskStatusList">
      <span class="moveicon"></span>

      <span class="fieldName">{{task.touchTypeName}}</span>

      <div class="outerTag" >

        <div class="likeTag" *ngFor="let statuses of task.statuses" >
          {{statuses.touchStatusName}}
                     
            <button mat-icon-button (click)="deleteStatusTask(task,statuses)">
               <mat-icon>close</mat-icon>
              </button>
        
        </div>
               
      </div>

      <!-- <ng-container *ngIf="task.isCommon">
       
        <span class="requried">
          <mat-slide-toggle color="primary" [disabled]="true">
          </mat-slide-toggle>
        </span>
  
        <span class="editField">
          <button mat-icon-button class="editbtn" [disabled]="true">
            <mat-icon>edit</mat-icon>
          </button>
        </span>  
      
     
      </ng-container> -->
      
      <!-- <ng-container *ngIf="!task.isCommon">
       
        <span class="requried">
          <mat-slide-toggle color="primary" [checked]="task.isActive" (change)="UpdateStatusToggle(task,$event)">
          </mat-slide-toggle>
        </span>
  
        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="UpdateTaskDialog(myUpdateDialog,task)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>  
       
      </ng-container> -->

    </div>

    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator> -->
       
  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>



<ng-template #myAddDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Add Task Status
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Status Name</mat-label>
      <input matInput [required]="true"  maxlength="50" placeholder="Add status name" 
      formControlName="statusname" (input)="onSearchChange($event.target.value)"/>
      <mat-error
      *ngIf="formDialog.get('statusname').invalid &&
        (formDialog.get('statusname').dirty ||
        formDialog.get('statusname').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>

    <mat-form-field class="example-full-width">
      <mat-label>Constant Name</mat-label>
      <input matInput readonly maxlength="50" formControlName="constantname"/>     
    </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty" 
  (click)="AddTaskStatus(formDialog.value)">
  Save
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<ng-template #myUpdateDialog>
  <form  [formGroup]="updateformDialog">
  <h2 mat-dialog-title>
      Update Task Status
      <button mat-icon-button (click)="closeUpdate()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Status Name</mat-label>
      <input matInput [required]="true"  maxlength="50" placeholder="update status name" 
      formControlName="statusname"/>
      <mat-error
      *ngIf="updateformDialog.get('statusname').invalid &&
        (updateformDialog.get('statusname').dirty ||
        updateformDialog.get('statusname').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>

    <!-- <mat-form-field class="example-full-width">
      <mat-label>Constant Name</mat-label>
      <input matInput readonly maxlength="50" formControlName="constantname"/>     
    </mat-form-field> -->

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="closeUpdate()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="updateformDialog.invalid || !updateformDialog.dirty" 
  (click)="UpdateTaskStatus(updateformDialog.value)">
  Update
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<app-loader></app-loader>